package ai.jessie.web.pages.organisations

import ai.jessie.web.onboarding.EntryState
import ai.jessie.web.onboarding.LocalOnboardingPort
import ai.jessie.web.onboarding.followEntry
import ai.jessie.web.onboarding.organisationSelector
import ai.jessie.web.theme.entryFrame
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting

@Page
@Composable
fun organisationsPage() {
    val port = LocalOnboardingPort.current
    val scope = rememberCoroutineScope()
    val model = remember(port, scope) { EntryState(port, scope) }
    LaunchedEffect(model) { if (!AppGlobals.isExporting) model.refresh() }
    followEntry(model.state.entry)
    entryFrame("Organisation auswählen", model.state.error?.authenticationRequired == true) {
        organisationSelector(model.state, model.actions)
    }
}
